import React from 'react';
import {
  Box,
  Container,
  Divider,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PrivateRoute from '../../auth/Routes/PrivateRoute';
import { Switch } from 'react-router-dom';
import {
  APPS_DASHBOARD_ROUTE,
  BUZZ_LICENSES_ROUTE,
  BUZZ_SUBSCRIPTION_PLANS_ROUTE,
  BUZZ_SUBSCRIPTIONS_ROUTE,
  DASHBOARD_MODULE_ROUTE,
  DISCOVERY_DASHBOARD_ROUTE,
  ENCRYPT_AND_DECRYPT_ROUTE,
  FEATURE_MANAGEMENT_ROUTE,
  HASHTAGS_DASHBOARD_ROUTE,
  JFT_DASHBOARD_ROUTE,
  MGMENT_DASHBOARD_ROUTE,
  NOTIFICATION_SERVICE_CONFIG_DASHBOARD_ROUTE,
} from '../../routes/routes';
import ManagementAppDash from './ManagementAppDashboard/ManagementAppDash';
import DiscoveryAppDash from './DiscoverAppDashboard/DiscoveryAppDash';
import JftDash from './JFTDashboard/JftDash';
import AppsListDash from './AppsListDash/AppsListDash';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import HashtagsDash from './Hashtags/Hashtags';
import BuzzSubscriptionPlans from './Buzz Subscription Products/BuzzSubscriptionPlans';
import BuzzSubscriptions from './Buzz Subscriptions/BuzzSubscriptions';
import BuzzLicenses from './Buzz Licenses/BuzzLicenses';
import NotificationServiceConfig from './NotificationServiceConfiguration/NotificationServiceConfig';
import EncryptAndDecrypt from './EncryptAndDecyrpt/EncryptAndDecyrpt';
import FeatureManagement from './FeatureManagement/FeatureManagement';
import DashboardSideNavBar from './DasboardSideNavBar';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    padding: 44,
    paddingTop: 24,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    fontFamily: 'Rubik',
  },
  underLine: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  pointer: { cursor: 'pointer' },
}));

function DashboardScreen() {
  const classes = useStyles();

  const location = useLocation();

  return (
    <Container
      className={
        location.pathname === '/dashboard/view-details' ? null : classes.overAll
      }>
      {location.pathname === '/dashboard/view-details' ? null : (
        <Box
          display="flex"
          flex={1}
          justifyContent="center"
          alignItems="center">
          <Box flex={1} flexGrow={1}>
            <Typography variant="h4" component="div">
              <Box fontWeight="fontWeightMedium">Dashboard</Box>
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              Managing Dashboard
            </Typography>
          </Box>
        </Box>
      )}
      <Divider />
      <Box display="flex" flex={10}>
        {location.pathname === '/dashboard/view-details' ? null : (
          <Box minWidth={300} pt={4}>
            <DashboardSideNavBar />
          </Box>
        )}

        <Box flex={9} pt={4}>
          <Switch>
            <PrivateRoute
              exact
              path={[MGMENT_DASHBOARD_ROUTE, DASHBOARD_MODULE_ROUTE]}
              component={ManagementAppDash}
            />
            <PrivateRoute
              exact
              path={DISCOVERY_DASHBOARD_ROUTE}
              component={DiscoveryAppDash}
            />
            <PrivateRoute
              exact
              path={JFT_DASHBOARD_ROUTE}
              component={JftDash}
            />
            <PrivateRoute
              exact
              path={APPS_DASHBOARD_ROUTE}
              component={AppsListDash}
            />
            <PrivateRoute
              exact
              path={NOTIFICATION_SERVICE_CONFIG_DASHBOARD_ROUTE}
              component={NotificationServiceConfig}
            />
            <PrivateRoute
              exact
              path={HASHTAGS_DASHBOARD_ROUTE}
              component={HashtagsDash}
            />
            <PrivateRoute
              exact
              path={BUZZ_SUBSCRIPTION_PLANS_ROUTE}
              component={BuzzSubscriptionPlans}
            />
            <PrivateRoute
              exact
              path={BUZZ_SUBSCRIPTIONS_ROUTE}
              component={BuzzSubscriptions}
            />
            <PrivateRoute
              exact
              path={BUZZ_LICENSES_ROUTE}
              component={BuzzLicenses}
            />
            <PrivateRoute
              exact
              path={ENCRYPT_AND_DECRYPT_ROUTE}
              component={EncryptAndDecrypt}
            />
            <PrivateRoute
              exact
              path={FEATURE_MANAGEMENT_ROUTE}
              component={FeatureManagement}
            />
          </Switch>
        </Box>
      </Box>
    </Container>
  );
}

export default DashboardScreen;
